import React from "react";

import ArrowLeft from "../../../resources/images/nftf/arrow-left.svg";
import { _O } from "../../../modules/utils";
import { HeaderTitle } from "./HeaderStyle";

const WhiteLeftArrowHeader = (props) => {
  return (
    <HeaderTitle>
      <div
        style={{ width: "40px", height: "40px" }}
        onClick={props.event ? props.event : () => _O.Open(props.moveUrl)}
      >
        <img src={ArrowLeft} />
      </div>
      <div>{props.title}</div>
      <div style={{ width: "40px", height: "40px" }}>{/* <img src={ArrowLeft} /> */}</div>
    </HeaderTitle>
  );
};

export default WhiteLeftArrowHeader;
